<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homes' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item>错题订正</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="mine_header p_m_t_30" id="tab">
			<div class=" header_left p_flex p_f_a ">
				<div class="p_flex p_f_a small_hand" v-for="(item, index) in headerList" :key="index" @click="goHeader(index)">
					<div :class="[headerIndex == index ? 'tababr_com' : '']">{{ item.name }}</div>
					<div v-show="headerIndex == index" class="header_heng"></div>
				</div>
			</div>
		</div>
		<div class="head_tab" id="tabHead">
			<div class="p_flex">
				<el-select v-model="postData.subject" placeholder="选择学科" @change="postData.page=1;getList()"><el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id" ></el-option></el-select>
				<div class="p_m_l_30"><el-date-picker v-model="timeFilter" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" ></el-date-picker></div>
			</div>
		</div>
		<div class="mine_list overflow small_hand error_list" :style="{ height: height + 'px' }">
			<error-list :i='headerIndex' :data="data"></error-list>
			<div class="p_flex p_f_c p_m_t_20 p_m_b_20" v-if="loading">加载中...</div>
			<div class="p_m_l_20 p_m_r_20" v-if="!isPullLoading"><el-divider>没有更多了</el-divider></div>
		</div>

	</div>
</template>

<script>
import ErrorHead from './components/head.vue'
import ErrorList from './components/list.vue'
export default {
	name: 'Mistakes',
	components:{
		ErrorHead,
		ErrorList
	},
	data() {
		return {
			headerIndex: 0,
			headerList: [ { name: '待订正' }, { name: '已完成' } ],
			show: false,
			height: 0,
			postData: { limit:10, page:1, wrong_correct_status:3, subject:0, start_date:null, end_date:null },
			isPullLoading: true,
			loading: false,
			data: { count:0, list:[] },
			subjectList: [],
			timeFilter: [],
		};
	},
	mounted() {
		this.indexInfo();
		this.getSubjectList()
		this.getList()
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Mistakes') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		},
		timeFilter(val){
			console.log(val)
			if( val && val.length == 2 ){
				this.postData.start_date = val[0]
				this.postData.end_date = val[1]
			}else{
				this.postData.start_date = null
				this.postData.end_date = null
			}
			this.getList()
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {

		getList(){
			this.loading = true
			this.$request.ajax(this).post('api_student/wrong_job_publish_list',this.postData).then(res=>{
				this.data = res.data
				this.loading = false
			})
		},

		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var tab = document.getElementById('tab');
			var tabHead = document.getElementById('tabHead').offsetHeight
			var tabHeight = tab.offsetHeight;
			var tabTop = tab.offsetTop;
			var height = box - head - tabHeight - tabHead - 50;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		// 头部切换
		goHeader(i) {
			this.headerIndex = i;
			this.postData.wrong_correct_status = (i==0)?3:1
			this.postData.page = 1
			this.data = { count:0, list:[] }
			this.getList()
		},

		getSubjectList(){
			this.$request.ajax(this).post('Library/subject').then(res=>{
				res.data.push({id:0, name:'全部'})
				this.subjectList = res.data
			})
		}

	}
};
</script>
<style lang="scss" scoped>
.mine_header {
	background-color: #fafafa;
	height: 60px;
}

.header_left > div {
	height: 100%;
	position: relative;
	margin-left: 260px;
}

.header_left > div:nth-child(2) {
	margin-left: 50px;
}

.header_left {
	height: 100%;
}

.header_heng {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 80%;
	height: 2px;
	background-color: #000000;
}
.tababr_com {
	font-weight: bold;
}
.heaer_btn {
	margin-left: 440px;
}
.mine_list {
	padding: 0 220px;
	background-color: #ffffff;
}
.head_tab{
	padding: 20px 260px;
	margin: 10px 0;
	background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/errors/index.vue